export const SET_PAYMENT_METHODS = '@payment/SET_PAYMENT_METHODS';
export const SET_PUB_KEY = '@payment/SET_PUB_KEY';
export const SET_SEPA_DATA = '@payment/SET_SEPA_DATA';
